// extracted by mini-css-extract-plugin
export default {"wholesale":"Wholesale_wholesale__gO2vy","status":"Wholesale_status__iqW2q"};